import { FamiliarityStatus } from "./models";

export const MockUsers: string[][] = [
  [
    "elton@probot.ai",
    "lara@probot.ai",
    "Lucy@probot.ai",
    "Sarahb@probot.ai",
    "stephanie@probot.ai",
    "steve@probot.ai",
    "Andrew.d@probot.ai",
    "Brian@probot.ai",
    "habib@probot.ai",
    "stella@probot.ai",
    "Allan@probot.ai",
    "Amy@probot.ai",
    "Frank.s@probot.ai",
    "rose.b@probot.ai",
    "Andrew@probot.ai",
    "miriam@probot.ai",
    "yusra@probot.ai",
    "dominick@probot.ai",
    "emilyrose@probot.ai",
    "John@probot.ai",
  ],
  [
    "mark@probot.ai",
    "shay@probot.ai",
    "brendon@probot.ai",
    "cody@probot.ai",
    "Heidi@probot.ai",
    "miranda@probot.ai",
    "sarahc@probot.ai",
    "dylon@probot.ai",
    "rene@probot.ai",
    "Ruth@probot.ai",
    "astrid@probot.ai",
    "connor@probot.ai",
    "jessica@probot.ai",
    "john.h@probot.ai",
    "norman@probot.ai",
    "omer@probot.ai",
    "Rachel@probot.ai",
    "Richard@probot.ai",
    "ryan@probot.ai",
    "vladimir@probot.ai",
    "aaron@probot.ai",
    "anita@probot.ai",
    "brian.l@probot.ai",
  ],
  [
    "Jim@probot.ai",
    "kingsley@probot.ai",
    "lena.s@probot.ai",
    "mia@probot.ai",
    "stephen@probot.ai",
    "william@probot.ai",
    "kaydee@probot.ai",
    "holly@probot.ai",
    "taybah@probot.ai",
    "vivek@probot.ai",
    "garin@probot.ai",
    "anees@probot.ai",
    "kailum@probot.ai",
    "tulisa@probot.ai",
    "aimie@probot.ai",
    "gerrard@probot.ai",
    "hajrah@probot.ai",
    "kobie@probot.ai",
    "kristian@probot.ai",
    "adnan@probot.ai",
    "noel@probot.ai",
    "lance@probot.ai",
    "saqlain@probot.ai",
    "adelaide@probot.ai",
    "leyton@probot.ai",
    "alina@probot.ai",
    "karen@probot.ai",
    "bret@probot.ai",
    "stefano@probot.ai",
    "martina@probot.ai",
    "rehan@probot.ai",
    "doris@probot.ai",
    "fay@probot.ai",
    "kya@probot.ai",
    "ayisha@probot.ai",
    "tanvir@probot.ai",
  ],
  [
    "roscoe@probot.ai",
    "inaaya@probot.ai",
    "farrah@probot.ai",
    "amanda@probot.ai",
    "affan@probot.ai",
    "maegan@probot.ai",
    "ashanti@probot.ai",
    "harriet@probot.ai",
    "aisling@probot.ai",
    "armani@probot.ai",
    "lilly-rose@probot.ai",
    "nabeel@probot.ai",
    "jett@probot.ai",
    "zoe@probot.ai",
    "cairo@probot.ai",
    "liliana@probot.ai",
    "kali@probot.ai",
    "ruari@probot.ai",
    "mylo@probot.ai",
  ],
];
